<template>
    <div>
      <el-row :gutter="20">
        <el-col :span="10">
          <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">裁判功能</span>
            </el-col>
          </el-row>
          <div class="button-container">
            <el-button type="primary" plain icon="el-icon-link" @click="copyFn('rank', 1)">大屏排名有分数</el-button>
            <el-button type="primary" plain icon="el-icon-link" @click="copyFn('rank', 0)">大屏排名无分数</el-button>
          </div>
        </el-card>
        </el-col>
        <el-col :span="14">
          <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col>
                    <span class="title_class">选手筛选</span>
                </el-col>
            </el-row>
            <el-form
                :model="queryForm"
                class="filter_Form"
                label-width="60px"
                ref="queryFormRef"
            >
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                        label="赛季"
                        prop="season"
                        style="margin-bottom: 0"
                    >
                        <el-select
                            placeholder="请选择"
                            style="width: 100%"
                            v-model="queryForm.season"
                            @change="seasonChange"
                        >
                            <el-option
                                v-for="item in dict_season"
                                :key="item.dictValue"
                                :label="item.dictLabel"
                                :value="item.dictValue"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="6">
                  <el-form-item label="赛程" prop="raceSchedule">
                    <el-select
                      placeholder="请选择"
                      style="width: 100%"
                      v-model="queryForm.raceSchedule"
                      @change="changeFn"
                    >
                      <el-option
                        v-for="item in dict_matchType"
                        :key="item.id"
                        :label="item.scheduleName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col> -->
                <el-col :span="8">
                    <el-form-item label="赛区" prop="districtId">
                        <el-select
                            placeholder="请选择"
                            filterable
                            style="width: 100%"
                            v-model="queryForm.districtId"
                            @change="changeFn"
                        >
                            <el-option
                                v-for="item in dict_district"
                                :key="item.id"
                                :label="item.districtName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item
                        label="考场"
                        prop="examRoomId"
                    >
                        <el-select
                            placeholder="请选择"
                            style="width: 100%"
                            v-model="examRoomId"
                            filterable
                            @change="examRoomChange"
                        >
                            <el-option
                                v-for="(item, index) in examRooms"
                                :key="index"
                                :label="item.roomName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                    <!-- <el-col :span="8">
                        <el-form-item label="姓名" prop="userName">
                            <el-input
                                v-model="queryForm.userName"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="手机号" prop="phone">
                            <el-input
                                v-model="queryForm.phone"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col> -->
                     <!--  <el-col :span="6">
                        <el-form-item label="学校名称" prop="schoolName">
                            <el-input
                                v-model="queryForm.schoolName"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col> -->
                    <!-- <el-col :span="8" align="right">
                      <el-button
                        type="primary"
                        @click="handleToSearch"
                        >查询</el-button
                    >
                    <el-button
                        type="primary"
                        plain
                        @click="handleToReset"
                        >重置</el-button
                    >
                    </el-col> -->
                </el-row>

            </el-form>
        </el-card>
        </el-col>
      </el-row>
        <!-- 考场管理 -->
        <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col :span="6">
                    <span class="title_class">选手管理</span>
                </el-col>
            </el-row>
            <el-table
                header-cell-class-name="tableHeaderStyle"
                :data="dataList"
                border
                stripe
            >
                <el-table-column
                    label="序号"
                    type="index"
                    width="50px"
                ></el-table-column>
                <el-table-column label="准考证号" prop="examinationNumber">
                    <template slot-scope="{ row }">
                        {{ row.examinationNumber || "-" }}
                    </template>
                </el-table-column>
                <el-table-column label="姓名" prop="examinationUserName">
                    <template slot-scope="{ row }">
                        {{ row.examinationUserName || "-" }}
                    </template>
                </el-table-column>
                <el-table-column label="手机号" prop="examinationUserPhone">
                    <template slot-scope="{ row }">
                        {{ row.examinationUserPhone || "-" }}
                    </template>
                </el-table-column>
                <el-table-column label="邮箱" prop="examinationUserEmail">
                    <template slot-scope="{ row }">
                        {{ row.examinationUserEmail || "-" }}
                    </template>
                </el-table-column>
                <el-table-column label="学校" prop="examinationUserSchoolName">
                    <template slot-scope="{ row }">
                        {{ row.examinationUserSchoolName || "-" }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="年级"
                    prop="examinationUserGrade"
                    :formatter="gradeFormat"
                ></el-table-column>
                <el-table-column
                    label="组别"
                    prop="examinationUserLevel"
                    :formatter="levelFormat"
                ></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.score === 0 ? 'danger' : scope.row.score > 0 ? 'success' : 'info'" size="mini">
                            {{ scope.row.score === 0 ? '错误' : scope.row.score > 0 ? '正确' : '未设置' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="240">
                    <template slot-scope="scope">
                        <el-checkbox size="small" v-model="scope.row.right" label="正确" border @change="handleRightFn(scope.row)"></el-checkbox>
                        <el-checkbox size="small" v-model="scope.row.wrong" label="错误" border @change="handleWrongFn(scope.row)"></el-checkbox>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForm.pageNum"
                :page-sizes="[10, 20, 40, 80]"
                :page-size="queryForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </el-card>
    </div>
</template>
<script>
import { queryDistrictPage } from '@/http/api'

export default {
  name: 'groupH',
  props: {
    flag: { // 1-A有组别  2-A无组别
      Type: String,
      default: 0
    }
  },
  data () {
    return {
      dict_group: this.$userInfo.dict_group(),
      dict_grade: this.$userInfo.getGradeData(),
      dict_district: [], // 赛区下拉列表
      dict_season: [],
      dict_matchType: [], // 赛程下拉列表
      dataList: [],
      total: 0,
      queryForm: {
        season: this.$chnEngStatusCode.defaultSeason,
        pageNum: 1,
        pageSize: 10,
        examinationId: this.$route.query.id,
        userName: '',
        phone: '',
        schoolName: '',
        sign: null, // 是否签到
        raceSchedule: '2', // 复赛
        scoreValid: false,
        phase: '4' // 当前轮次
      },
      examRoomId: '',
      examInfo: {
        matchTng: 0,
        label: ''
      },
      examRooms: []
    }
  },
  created () {
  },
  methods: {
    init () {
      // 赛季数据
      this.$userInfo.getDataList(this, 't_season').then(value => {
        this.dict_season = value
      })
      // 赛区数据
      this.getDistrictList()

      // 赛程数据--默认传入复赛 2 写死的
      this.$chnEngPublicRequest.querySeasonRaceSchedule(this, {}).then(value => {
        this.dict_matchType = value
      })
    },
    changeFn () {
      this.examRoomId = ''
      this.getExamRoomSelect()
    },
    copyFn (type, isShowScore) {
      var loc = window.location.origin
      var input = document.createElement('input') // 创建input标签
      if (type === 'rank') {
        if (!this.examRoomId) return this.$message.warning('请选择考场')

        const query = {
          activityType: this.$chnEngStatusCode.activityType,
          season: this.queryForm.season,
          group: 1,
          raceSchedule: this.queryForm.raceSchedule,
          phase: this.queryForm.phase,
          examinationRoomId: this.examRoomId,
          isShowScore: isShowScore,
          districtId: this.queryForm.districtId
        }
        console.log(query)
        input.value = `${loc}/#/semiRank?${this.$xcUtils.serialize(query)}` // 将input的值设置为需要复制的内容
        document.body.appendChild(input) // 添加input标签
        input.select() // 选中input标签
        document.execCommand('copy') // 执行复制
        this.$message.success('复制成功') // 成功提示信息
        document.body.removeChild(input) // 移除input标签
      }
    },
    // 获取考场列表
    getExamRoomSelect () {
      this.$http.get('examination/queryExaminationList', { params: this.queryForm }).then(res => {
        this.examRooms = res.data || []
        if (this.examRoomId) { // 路径带入，直接获取信息
          this.examRoomInfo = this.examRooms.find(item => item.id === this.examRoomId)
          this.loading = true
        }
      }).catch((err) => {
        console.log('err', err)
        this.examRooms = []
      })
    },
    seasonChange () {
      // this.getList()
    },
    // 切换考场
    examRoomChange (e) {
      // 修改考场信息
      this.examRoomInfo = this.examRooms.find(item => item.id === this.examRoomId) || null
      this.loading = true
      this.queryForm.examinationId = this.examRoomId
      this.getList()
    },
    // 获取赛区筛选数据
    getDistrictList (districtId) {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list || []
        // if (this.dict_district.length > 1) {
        //   this.queryForm.districtId = districtId || this.dict_district[1].id
        // }
        this.getExamRoomSelect()
      }).catch((err) => {
        console.log('err', err)
        this.dict_district = []
        this.getExamRoomSelect()
      })
    },
    init3E () {
      this.init()

      const params = this.$route.query
      if (params.id) {
        this.queryForm.season = params.s
        this.queryForm.districtId = params.d
        this.examRoomId = params.id
      }
      if (this.examRoomId) {
        this.handleToSearch()
      }
    },
    handleToSearch () {
      this.queryForm.pageNum = 1
      this.getList()
    },
    handleToReset () {
      this.$refs.queryFormRef.resetFields()
      this.getList()
    },
    getList () {
      this.$http.get('examinationUser/queryUsersByRound', {
        params: this.queryForm
      }).then(res => {
        if (res.code === 200) {
          res.data.list.forEach(item => {
            item.right = item.score > 0
            item.wrong = item.score === 0
          })
          this.dataList = res.data.list
          this.total = res.data.total
        }
      })
    },
    handleSizeChange (e) {
      this.queryForm.pageSize = e
      this.getList()
    },
    handleCurrentChange (e) {
      this.queryForm.pageNum = e
      this.getList()
    },
    levelFormat (row) {
      const level = row.examinationUserLevel || row.enrollmentLevel
      return level ? this.dict_group.find(item => Number(item.dictValue) === level).dictLabel : '-'
    },
    handleRightFn (item) {
      if (item.right) {
        this.handleSetScore(item, true)
      } else {
        this.handleSetScore(item, false)
      }
    },
    handleWrongFn (item) {
      if (item.wrong) {
        this.handleSetScore(item, false)
      } else {
        this.handleSetScore(item, true)
      }
    },
    handleSetScore (row, right) {
      this.$http.post('examinationUser/setScoreRoundFour', {
        enrollmentRoundInfoId: row.tbEnrollmentRoundInfos[0].id,
        right: right
      }).then(res => {
        if (res.code === 200) {
          // this.$message.success(right ? '回答正确' : '回答错误')
          this.getList()
        } else {
          this.$message.error(res.msg || '操作失败')
        }
      })
    },
    gradeFormat (row) {
      const grade = row.examinationUserGrade || row.grade
      return grade ? this.dict_grade.find(item => item.dictCode === grade).dictLabel : '-'
    }
  }
}
</script>
<style lang="less" scoped>
.button-container{
  min-height: 62px;
}
</style>
